import * as Yup from 'yup';
import PropTypes from 'prop-types';

// Function to format the current date as YYYY-MM-DD (or any other required format)
const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
};

export const WalletPropTypes = PropTypes.shape({
  _id: PropTypes.string,
  payment_date: PropTypes.string,
  payment_type: PropTypes.string,
  amount: PropTypes.number,
  mode: PropTypes.string,
  remarks: PropTypes.string,
  agentId: PropTypes.string,
});

export const WalletDefaultProps = {
  payment_date: getCurrentDate(), // Set the current date as default
  instrument_number: '',
  payment_type: 'Advance_Payment',
  amount: 0,
  mode: 'NEFT_RTGS',
  remarks: '',
  agentId: '',
  category: 'debit',
};

export const WalletYupSchema = Yup.object().shape({
  payment_date: Yup.string(),
  payment_type: Yup.string(),
  amount: Yup.number(),
  mode: Yup.string(),
  remarks: Yup.string(),
  agentId: Yup.string(),
});

export default {
  WalletDefaultProps,
  WalletPropTypes,
  WalletYupSchema,
};
